/* eslint-disable import/prefer-default-export */
import { PasswordStrengthErrors, PasswordRequirements } from '€lib/strings/types';

export function passwordStrength(
    password: string,
    confirmPassword: string,
): [boolean, PasswordStrengthErrors] {
    const errors: PasswordStrengthErrors = {};

    if (password.length < 8) {
        errors[PasswordRequirements.Length] = 'Must be at least 8 characters long';
    }

    if (password === '' || confirmPassword === '' || password !== confirmPassword) {
        errors[PasswordRequirements.Match] = 'Must match';
    }

    if (!/[0-9]/.test(password)) {
        errors[PasswordRequirements.Number] = 'Needs a number';
    }

    if (!/[A-Z]/.test(password)) {
        errors[PasswordRequirements.UpperCase] = 'Needs Upper Case Letter';
    }

    if (!/[a-z]/.test(password)) {
        errors[PasswordRequirements.LowerCase] = 'Needs lowercase Letter';
    }

    // if we strip out all alphanumeric and whitespace then anything left must be a special character
    const stripped = password
        .replace(/[\s]/g, '')
        .replace(/[A-Z]/g, '')
        .replace(/[a-z]/g, '')
        .replace(/[0-9]/g, '');

    if (stripped.length === 0) {
        errors[PasswordRequirements.SpecialCharacter] = 'Needs special character e.g *^&$@£';
    }

    return [Object.keys(errors).length === 0, errors];
}
